var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321.86 176.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.57,55.62a26,26,0,0,1-26,26H0V0H51.42a22.09,22.09,0,0,1,22,22,21.62,21.62,0,0,1-3.49,11.89A26,26,0,0,1,81.57,55.62Zm-67-26.11h37a7.47,7.47,0,0,0,0-14.93h-37Zm41,37.42a11.43,11.43,0,0,0,0-22.85h-41v23h41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169,40.82A40.81,40.81,0,1,1,128.2,0h0A40.84,40.84,0,0,1,169,40.82Zm-14.57,0A26.23,26.23,0,1,0,128.2,67.05a26.23,26.23,0,0,0,26.23-26.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.2,81.62H229.87l-7.46-14.57-17.84-35-17.83,35-7.47,14.57H163l7.46-14.57L204.57,0l34.16,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.57,94.7v81.61L67,165.12,14.54,124.66v51.65H0V94.93l14.58,11.2L67,146.58v-52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.93,135.39a40.81,40.81,0,1,1-40.81-40.81h0A40.86,40.86,0,0,1,171.93,135.39Zm-14.58,0a26.23,26.23,0,1,0-26.23,26.23A26.23,26.23,0,0,0,157.35,135.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.47,94.7v14.57H221v67H206.44v-67H173V94.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.86,176.2H305.54l-7.47-14.58-17.83-35-17.84,35-7.46,14.58H238.61l7.47-14.58,34.16-67,34.16,67Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.eac5fecb616126d4fa6716c9e76182e3.svg";
export { ForwardRef as ReactComponent };